import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Button,
  ConfigProvider,
  DatePicker,
  Form,
  Input,
  Select,
  Space,
  Switch,
  Collapse,
} from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import {
  createNewsRequest,
  getNewsCategoriesRequest,
} from 'modules/newsModule/requests/newsRequests';
import 'moment-timezone';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import TextEditor from 'modules/layoutModule/components/TextEditor/TextEditor';
import { FieldData } from 'rc-field-form/lib/interface';
import copyToClipboard from 'helpers/copyToClipboard';
const { TextArea } = Input;
const { Panel } = Collapse;

const NewsAdd = (): JSX.Element => {
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [form] = Form.useForm();
  const [categories, setCategories] = useState([]);
  const [cover, setCover] = useState<string | null>(null);
  const [fields, setFields] = useState<FieldData[]>([]);

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  useEffect(() => {
    getNewsCategoriesRequest().then((response) => {
      if (response) {
        const { data } = response;
        const onlyActiveCategories = data.filter(
          (category: { isActive: boolean }) => category.isActive
        );
        const categories = onlyActiveCategories.map(
          (category: { name: string; id: number }) => {
            return {
              label: category.name,
              value: category.id,
            };
          }
        );
        setCategories(categories);
      }
    });
  }, []);

  const onSubmitForm = (values: any) => {
    toggleButtonLoading(true);
    createNewsRequest(values).then(() => toggleButtonLoading(false));
  };

  const onContentEdit = (e: any) => {
    setFields([
      {
        name: ['content'],
        value: e,
      },
    ]);
  };

  const updateCover = (e: string) => {
    setFields([
      {
        name: ['image'],
        value: e,
      },
    ]);
    setCover(e);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Aktualności</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/news">Lista newsów</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/news/add">Dodaj newsa</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <div className="site-layout-background">
        <ConfigProvider locale={plPL}>
          <Form
            layout="vertical"
            validateMessages={validateMessages}
            onFinish={onSubmitForm}
            form={form}
            fields={fields}
          >
            <Form.Item
              name="image"
              label="Okładka"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <FormCoverUpload
                cover={cover}
                setCover={updateCover}
                isNew
                field="fileImage1"
                number={1}
              />
            </Form.Item>
            <Form.Item
              name="alt1"
              label="Opis zdjęcia okładki (widoczne po dodaniu w treści wybranego kodu)"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="dateAdd"
              label="Data dodania"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              {/*// @ts-ignore*/}
              <DatePicker showTime />
            </Form.Item>
            <Form.Item
              name="idCategory"
              label="Kategoria"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Wybierz kategorię"
                optionFilterProp="children"
                options={categories}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item
              name="name"
              label="Tytuł"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="content"
              label="Treść"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              {/* @ts-ignore */}
              <TextEditor onChange={onContentEdit} disableGallery />
            </Form.Item>
            <div className="tables-collapse">
              <Collapse defaultActiveKey={[]}>
                <Panel header="Tabelka 1" key="1" forceRender>
                  <Form.Item name="table1" label="Tabelka 1">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#1')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#1
                  </Button>
                </Panel>
                <Panel header="Tabelka 2" key="2" forceRender>
                  <Form.Item name="table2" label="Tabelka 2">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#2')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#2
                  </Button>
                </Panel>
                <Panel header="Tabelka 3" key="3" forceRender>
                  <Form.Item name="table3" label="Tabelka 3">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#3')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#3
                  </Button>
                </Panel>
                <Panel header="Tabelka 4" key="4" forceRender>
                  <Form.Item name="table4" label="Tabelka 4">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#4')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#4
                  </Button>
                </Panel>
                <Panel header="Tabelka 5" key="5" forceRender>
                  <Form.Item name="table5" label="Tabelka 5">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#5')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#5
                  </Button>
                </Panel>
              </Collapse>
            </div>
            <Form.Item
              name="isActive"
              label="Aktywność"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  loading={isSaveButtonLoading}
                >
                  Zapisz
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </ConfigProvider>
      </div>
    </>
  );
};

export default NewsAdd;
